import React from 'react'

const CustomTab = ({ children, active, onClick, disabled, className, image, ...props }) => {

  return (
    <div
      className={`${disabled ? 'cursor-not-allowed text-rand-200' :
        active ? 'bg-secondary-100 text-secondary-500 cursor-default' : 'text-rand-200 cursor-pointer hover:bg-gray-100 bg-white'} text-center text-sm font-bold leading-none${className ? ` ${className}` : ''}`}
      onClick={onClick} {...props}>
      {image ?
        <div className="flex items-center space-x-2 justify-center">
          <div>{image}</div>
          <div>{children}</div>
        </div>
        : children
      }
    </div>
  )
}
export const CommonTab = ({ children, active, onClick, disabled, className, ...props }) => {
  return (
    <button
      className={`${disabled ? 'cursor-not-allowed text-rand-200' :
        active ? 'text-rand-100  border-secondary-500 cursor-default' : 'text-rand-200 border-transparent hover:border-rand-300'} focus:outline-none px-6 py-2 text-sm font-medium border-b-2 ${className ? ` ${className}` : ''}`}
      onClick={onClick} {...props}>
      {children}
    </button>
  )
}
export const TabCardHeader = ({ label, active, onClick, disabled, className, ...props }) => {
  return (
    <div
      className={`${active ? 'cursor-default' : 'text-gray-200 cursor-pointer'
      } px-1 h-full text-center text-base relative group mr-2 flex items-center justify-center min-w-[90px]`}
      onClick={onClick}>
      {label}
      <div
        className={`absolute left-0 right-0 bottom-0 h-[4px] rounded-tl rounded-tr${active ? ' bg-rand-100' : ' group-hover:bg-gray-100'}`} />
    </div>
  )
}
export default CustomTab

export const CustomTabRef = React.forwardRef(({
                                                children, active, onClick, disabled, className,
                                                ...props
                                              }, ref) => (
  <span
    ref={ref} className={`${disabled ? 'cursor-not-allowed text-rand-200' :
    active ? 'bg-secondary-100 text-secondary-500 cursor-default' : 'text-rand-200 cursor-pointer hover:bg-gray-100'} text-center text-sm font-bold leading-none${className ? ` ${className}` : ''}`}
    onClick={onClick} {...props}>
    {children}
  </span>
))
